module.exports = __webpack_public_path__ + "img/planting_02.0dfa474.webp";